const SET_LIST = 'GRID2/SET_LIST';
const ADD_ITEM = 'GRID2/ADD_ITEM';
const REMOVE_ITEM = 'GRID2/REMOVE_ITEM';
const CHANGE_ITEM = 'GRID2/CHANGE_ITEM';
const SET_LIST_MULTI_ROW = 'GRID2/SET_LIST_MULTI_ROW';
const ADD_ITEM_MULTI_ROW = 'GRID2/ADD_ITEM_MULTI_ROW';
const REMOVE_ITEM_MULTI_ROW = 'GRID2/REMOVE_ITEM_MULTI_ROW';
const CHANGE_ITEM_MULTI_ROW = 'GRID2/CHANGE_ITEM_MULTI_ROW';
const MOVE_ITEM_MULTI_ROW = 'GRID2/MOVE_ITEM_MULTI_ROW';
const MOVE_ITEM = 'GRID2/MOVE_ITEM';
const SET_EDIT_DIALOG_DATA = 'GRID2/SET_EDIT_DIALOG_DATA';
const SAVE_SELECTED_ITEMS = 'GRID2/SAVE_SELECTED_ITEMS';
const SAVE_SCROLL_POSITION = 'GRID2/SAVE_SCROLL_POSITION';
const SAVE_GRID_VIEW_STATE = 'GRID2/SAVE_GRID_VIEW_STATE';

export default {
  /** 一覧設定 */
  SET_LIST,

  /** 行追加 */
  ADD_ITEM,

  /** 行削除 */
  REMOVE_ITEM,

  /** 行変更 */
  CHANGE_ITEM,

  /** 行移動 */
  MOVE_ITEM,

  /** 一覧設定（MultiRow） */
  SET_LIST_MULTI_ROW,

  /** 行追加（MultiRow） */
  ADD_ITEM_MULTI_ROW,

  /** 行削除（MultiRow） */
  REMOVE_ITEM_MULTI_ROW,

  /** 行変更（MultiRow） */
  CHANGE_ITEM_MULTI_ROW,

  /** 行移動（MultiRow） */
  MOVE_ITEM_MULTI_ROW,

  /** 編集ダイアログデータ設定 */
  SET_EDIT_DIALOG_DATA,

  /** 選択データ保存 */
  SAVE_SELECTED_ITEMS,

  /** スクロール位置保存 */
  SAVE_SCROLL_POSITION,

  /** グリッド表示状態保存 */
  SAVE_GRID_VIEW_STATE,
};
